<template>
  <v-combobox
    v-model="selected"
    :filter="filter"
    :hide-no-data="!search"
    :items="commissions"
    :search-input.sync="search"
    item-text="title"
    item-value="id"
    label="Vorberatende Kommission"
    chips
    hide-selected
    clearable
    box
  >
    <template slot="no-data">
      <v-list-tile>
        <span class="subheading">Kommission mit dem Namen</span>
        <b class="px-2">{{ search }}</b>
        <span class="subheading">erstellen</span>
      </v-list-tile>
    </template>
    <template
      slot="item"
      slot-scope="{ index, item, parent }"
    >
      <v-list-tile-content>
        <v-text-field
          v-if="editing === item"
          v-model="editing.title"
          @keyup.enter="edit(item)"
          @click.stop
          style="width: 100%;"
          background-color="transparent"
          hide-details
          autofocus
          flat
        ></v-text-field>
        <span v-else>{{ item.title }}</span>
      </v-list-tile-content>
      <v-spacer></v-spacer>
      <v-list-tile-action @click.stop>
        <v-btn
          icon
          @click.stop.prevent="edit(item)"
        >
          <v-icon>{{ editing !== item ? 'edit' : 'check' }}</v-icon>
        </v-btn>
      </v-list-tile-action>
      <v-list-tile-action v-if="editing !== item" @click.stop>
        <v-btn
          icon
          @click.stop.prevent="item.destroy"
        >
          <v-icon color="red">delete</v-icon>
        </v-btn>
      </v-list-tile-action>
    </template>
  </v-combobox>
</template>

<script>
export default {
  name: 'CRUDCombobox',
  props: ['value', 'model'],
  data() {
    return {
      editing: null,
      selected: this.model.find(this.value),
      search: null,
    };
  },
  computed: {
    commissions() {
      return [
        { header: 'Komission auswählen oder erstellen' },
      ].concat(this.model.query().orderBy('title').all());
    },
  },
  watch: {
    async selected(val) {
      if (typeof val === 'string') {
        const Model = this.model;
        const commission = await new Model({ title: val }).save();
        this.$emit('input', commission.id);
      } else {
        this.$emit('input', (val && val.id));
      }
    },
    value(val) {
      this.selected = this.model.find(val);
    },
  },
  methods: {
    async edit(item) {
      if (!this.editing) {
        this.editing = item;
      } else {
        item.update();
        this.editing = null;
      }
    },
    async destroy(item) {
      await item.destroy();
    },
    filter(item, queryText, itemText) {
      if (item.header) return false;

      const hasValue = val => val || '';

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return text.toString()
        .toLowerCase()
        .indexOf(query.toString().toLowerCase()) > -1;
    },
  },
};
</script>
